import request from 'services/request';
import { endpoints } from 'services/endpoints';
import { paramsToFormData } from 'utils/utils';
import { PagingReqDto } from '../../types';

export interface SocietyBoardListRequest extends PagingReqDto {
  /** 카테고리 목록 */
  cateList?: string;
  /** 서브 카테고리 목록 */
  subCateList?: string;
  /** 게시판 유형 */
  boardType?: string;
  /** 상단 통함 검색어 */
  topSearchWord?: string;
  /** 게시판 내 검색어 */
  searchWordIn?: string;
}

export interface SocietyBoardWriteReq {
  attachFiles: File[];
  cateId: string;
  contents: string;
  contentsText: string;
  subCateId: string;
  boardType: string;
  tags: Array<string>;
  title: string;
}

export interface SocietyBoardUpdateReq extends SocietyBoardDetailReqDto {
  uploadedFiles: AttachFileResDto[];
}

export interface SocietyBoardLikeReq {
  boardId: string;
}

export interface SocietyBoardDeleteReq {
  boardId: string;
}

export default {
  /** 게시글 목록 조회 */
  getSocietyBoardList: (params: SocietyBoardListRequest): Promise<SocietyBoardListResDto> =>
    request({
      url: endpoints.societyBoard.societyBoard,
      method: 'get',
      params,
    }),
  /** 게시글 상세 내용 조회 */
  getSocietyBoardDetail: (url: string): Promise<SocietyBoardDetailResDto> =>
    request({
      url,
      method: 'get',
    }),
  /** 게시글 작성 */
  postSocietyBoardWrite: (params: SocietyBoardWriteReq): Promise<BaseResDto> => {
    const postParams = {
      ...params,
      boardType: params.boardType || 'SOCIETY_BOARD',
    } as SocietyBoardDetailReqDto;

    if (!!params.attachFiles?.length) {
      for (let i = 0; i < params.attachFiles.length; i++) {
        postParams['attachFiles[' + i + '].attachFile'] = params.attachFiles[i];
        postParams['attachFiles[' + i + '].attachFileId'] = '0';
      }
    }

    delete postParams.attachFiles;

    const formData = paramsToFormData(postParams);

    return request(
      {
        url: endpoints.societyBoard.societyBoardWrite,
        method: 'post',
        data: formData,
      },
      {
        multiPart: true,
      }
    );
  },
  /** 게시글 수정 */
  putSocietyBoardUpdate: (url: string, params: SocietyBoardUpdateReq): Promise<BaseResDto> => {
    const postParams = {
      ...params,
      boardType: params.boardType || 'SOCIETY_BOARD',
    };

    const uploadedFilesLength = postParams.uploadedFiles.length;

    for (let i = 0; i < uploadedFilesLength; i++) {
      postParams['attachFiles[' + i + '].attachFileId'] = postParams.uploadedFiles[i].fileId;
    }

    if (!!postParams.attachFiles?.length) {
      for (let i = 0; i < postParams.attachFiles.length; i++) {
        postParams['attachFiles[' + (uploadedFilesLength + i) + '].attachFile'] = postParams.attachFiles[i];
        postParams['attachFiles[' + (uploadedFilesLength + i) + '].attachFileId'] = '0';
      }
    }

    delete postParams.attachFiles;

    const formData = paramsToFormData(postParams);

    return request(
      {
        url: url,
        method: 'put',
        data: formData,
      },
      {
        multiPart: true,
      }
    );
  },
  /** 게시글 좋아요 */
  postSocietyBoardLike: (params: SocietyBoardLikeReq): Promise<BaseResDto> =>
    request({
      url: endpoints.societyBoard.societyBoardLike,
      method: 'post',
      params,
    }),
  /** 게시글 삭제 */
  deleteSocietyBoard: (url: string, params?: SocietyBoardDeleteReq): Promise<BaseResDto> =>
    request({
      url,
      method: 'delete',
      params,
    }),
  /** 게시글 공유 */
  shareSocietyBoard: (params: ShareReqDto): Promise<BaseResDto> =>
    request({
      url: endpoints.societyBoard.societyBoardShare,
      method: 'post',
      data: params,
    }),
};
